<template>
  <FinderCard
    data-test="finder-conditions-card"
    :title="criterion.title"
    :tooltip="criterion.tooltip"
  >
    <ul class="flex flex-col gap-8">
      <li
        v-for="(option, index) in criterion.options"
        :key="option.id"
        class="flex-1 flex"
      >
        <RevButtonBase
          :aria-pressed="isGradeSelected(index)"
          class="flex flex-1 h-full items-center rounded-lg border-1 border-transparent px-16 py-14 motion-safe:transition motion-safe:duration-[225ms] outline-2 outline-offset-4 focus-visible:outline-default-hi"
          :class="
            isGradeSelected(index)
              ? 'bg-action-default-mid-pressed text-onaction-default-mid-pressed hover:bg-action-default-mid-hoverpressed'
              : 'bg-action-default-mid text-onaction-default-mid hover:bg-action-default-mid-hover'
          "
          :data-state="isGradeSelected(index) ? 'selected' : 'unselected'"
          :data-test="`finder-conditions-option-${option.id}`"
          @click="handleClick(option.id)"
        >
          <span class="heading-3">{{ option.label }}</span>
        </RevButtonBase>
      </li>
    </ul>
  </FinderCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { RevButtonBase } from '@ds/components/ButtonBase'

import type { FinderConditionsCriterion } from '../../../../composables/useFinder/useFinder.types'
import FinderCard from '../FinderCard/FinderCard.vue'

const props = defineProps<{
  criterion: FinderConditionsCriterion
}>()

const model = defineModel<string | undefined>()

const thresholdIndex = computed(() => {
  if (!model.value) return -1

  return props.criterion.options.findIndex(
    (option) => option.id === model.value,
  )
})

function isGradeSelected(index: number): boolean {
  return thresholdIndex.value >= 0 && index >= thresholdIndex.value
}

function handleClick(optionId: string): void {
  model.value = model.value === optionId ? undefined : optionId
}
</script>
